import { MaintenanceRequest } from '@/types/maintenance';

const maintenanceIssues = [
  'Leaking Faucet',
  'Broken Air Conditioning',
  'Electrical Outlet Not Working',
  'Plumbing Issue',
  'Door Lock Malfunction',
  'Window Won\'t Close',
  'Heating System Problem',
  'Kitchen Sink Clogged',
  'Bathroom Fan Broken',
  'Light Fixture Replacement',
  'Carpet Cleaning Required',
  'Paint Touch-up Needed',
  'Balcony Railing Loose',
  'Garbage Disposal Broken',
  'Smoke Detector Battery',
  'Fire Alarm Testing',
  'Elevator Maintenance',
  'Pool Equipment Repair',
  'Gym Equipment Fix',
  'Parking Gate Issue'
];

const descriptions = [
  'Kitchen faucet is leaking and needs repair',
  'AC unit not cooling properly, needs inspection',
  'Electrical outlet in living room not working',
  'Bathroom sink is clogged and water backing up',
  'Front door lock mechanism is stuck',
  'Bedroom window won\'t close properly',
  'Heating system not working in winter',
  'Kitchen sink is completely clogged',
  'Bathroom exhaust fan making loud noise',
  'Living room light fixture needs replacement',
  'Carpet has stains that need professional cleaning',
  'Wall paint is peeling in several areas',
  'Balcony railing is loose and unsafe',
  'Garbage disposal unit is jammed',
  'Smoke detector battery needs replacement',
  'Fire alarm system needs annual testing',
  'Elevator is making strange noises',
  'Pool pump is not working properly',
  'Treadmill in gym is broken',
  'Parking gate is not responding to remote'
];

const residents = [
  { id: 'RES001', name: 'John Doe' },
  { id: 'RES002', name: 'Jane Smith' },
  { id: 'RES003', name: 'Mike Johnson' },
  { id: 'RES004', name: 'Sarah Wilson' },
  { id: 'RES005', name: 'David Brown' },
  { id: 'RES006', name: 'Lisa Davis' },
  { id: 'RES007', name: 'Robert Miller' },
  { id: 'RES008', name: 'Jennifer Garcia' },
  { id: 'RES009', name: 'William Rodriguez' },
  { id: 'RES010', name: 'Maria Martinez' }
];

const units = [
  { id: 'UNIT001', name: 'Unit 101' },
  { id: 'UNIT002', name: 'Unit 102' },
  { id: 'UNIT003', name: 'Unit 103' },
  { id: 'UNIT004', name: 'Unit 201' },
  { id: 'UNIT005', name: 'Unit 202' },
  { id: 'UNIT006', name: 'Unit 203' },
  { id: 'UNIT007', name: 'Unit 301' },
  { id: 'UNIT008', name: 'Unit 302' },
  { id: 'UNIT009', name: 'Unit 303' },
  { id: 'UNIT010', name: 'Unit 401' }
];

const blocks = [
  { id: 'BLOCK001', name: 'Block A' },
  { id: 'BLOCK002', name: 'Block B' },
  { id: 'BLOCK003', name: 'Block C' },
  { id: 'BLOCK004', name: 'Block D' }
];

const employees = [
  { id: 'EMP001', name: 'Mike Johnson' },
  { id: 'EMP002', name: 'Tom Wilson' },
  { id: 'EMP003', name: 'Chris Davis' },
  { id: 'EMP004', name: 'Alex Brown' },
  { id: 'EMP005', name: 'Sam Miller' }
];

const statuses: MaintenanceRequest['status'][] = ['Open', 'In Progress', 'On Hold', 'Resolved'];
const priorities: MaintenanceRequest['priority'][] = ['Low', 'Medium', 'High', 'Urgent'];

export const maintenanceRequests: MaintenanceRequest[] = Array.from({ length: 50 }, (_, idx) => {
  const issueIndex = idx % maintenanceIssues.length;
  const residentIndex = idx % residents.length;
  const unitIndex = idx % units.length;
  const blockIndex = idx % blocks.length;
  const employeeIndex = idx % employees.length;
  const statusIndex = idx % statuses.length;
  const priorityIndex = idx % priorities.length;
  
  const createdAt = new Date();
  createdAt.setDate(createdAt.getDate() - Math.floor(Math.random() * 30));
  
  const updatedAt = new Date(createdAt);
  updatedAt.setDate(updatedAt.getDate() + Math.floor(Math.random() * 7));
  
  return {
    id: `MNT${(idx + 1).toString().padStart(3, '0')}`,
    title: maintenanceIssues[issueIndex],
    description: descriptions[issueIndex],
    status: statuses[statusIndex],
    priority: priorities[priorityIndex],
    reportedBy: residents[residentIndex],
    apartmentUnit: units[unitIndex],
    block: blocks[blockIndex],
    assignedTo: employees[employeeIndex],
    workspace: {
      id: 'demo-workspace',
      name: 'Sunset Gardens',
      slug: 'demo-workspace'
    },
    attachments: Math.random() > 0.7 ? [
      {
        id: `ATT${(idx + 1).toString().padStart(3, '0')}`,
        name: 'Issue Image',
        type: 'image',
        size: 1024 + Math.floor(Math.random() * 5000),
        path: `/documents/maintenance/MNT${(idx + 1).toString().padStart(3, '0')}/issue.jpg`,
        url: `https://example.com/images/issue-${idx + 1}.jpg`,
        uploadedAt: new Date(createdAt.getTime() + Math.floor(Math.random() * 24 * 60 * 60 * 1000))
      }
    ] : [],
    resolutionNotes: statuses[statusIndex] === 'Resolved' ? `Issue resolved on ${updatedAt.toLocaleDateString()}. All systems working properly.` : undefined,
    comments: Math.random() > 0.5 ? [
      {
        id: `COM${(idx + 1).toString().padStart(3, '0')}`,
        content: 'Technician assigned to this issue.',
        author: {
          id: employees[employeeIndex].id,
          name: employees[employeeIndex].name,
          type: 'employee' as const
        },
        createdAt: new Date(createdAt.getTime() + Math.floor(Math.random() * 24 * 60 * 60 * 1000))
      }
    ] : [],
    createdAt,
    updatedAt,
    activityRecords: [
      {
        timestamp: createdAt,
        type: 'created',
        performedBy: {
          id: residents[residentIndex].id,
          displayName: residents[residentIndex].name
        }
      },
      ...(statuses[statusIndex] !== 'Open' ? [{
        timestamp: new Date(createdAt.getTime() + Math.floor(Math.random() * 24 * 60 * 60 * 1000)),
        type: 'updated' as const,
        performedBy: {
          id: employees[employeeIndex].id,
          displayName: employees[employeeIndex].name
        },
        details: `Status changed to ${statuses[statusIndex]}`
      }] : [])
    ]
  };
}); 